import React from 'react';
import { formatByHint } from './criteriaBarUtils';

const VALUE_SIZE_CLASS = {
  xs: 'text-[11px] font-medium',
  sm: 'text-sm font-semibold',
  md: 'text-base font-semibold',
  lg: 'text-lg font-semibold',
};

const STACKED_LABEL_CLASS = 'text-[10px] uppercase tracking-wider text-white/45';

function resolveValue(value, hint, currency) {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'number') return hint ? formatByHint(value, hint, currency) : String(value);
  return String(value);
}

export default function MetricSingle({
  label,
  value,
  hint,
  currency = 'USD',
  secondary = null,
  size = 'sm',
  layout = 'inline',
  valueClassName = '',
  labelClassName = '',
  className = '',
}) {
  const valueText = resolveValue(value, hint, currency);
  const valueSizeClass = VALUE_SIZE_CLASS[size] || VALUE_SIZE_CLASS.sm;

  const valueNode = (
    <span className={`text-white tabular-nums whitespace-nowrap ${valueSizeClass} ${valueClassName}`}>
      {valueText}
    </span>
  );

  const secondaryNode = secondary ? (
    <span className="ml-2 text-white/50 text-xs font-medium tabular-nums">
      {secondary.label ? `${secondary.label} ` : ''}
      {resolveValue(secondary.value, secondary.hint ?? hint, secondary.currency ?? currency)}
    </span>
  ) : null;

  if (layout === 'stacked') {
    return (
      <div className={className}>
        {label ? (
          <div className={`${STACKED_LABEL_CLASS} ${labelClassName}`}>{label}</div>
        ) : null}
        <div className={label ? 'mt-1' : undefined}>
          {valueNode}
          {secondaryNode}
        </div>
      </div>
    );
  }

  return (
    <span className={`text-white/70 ${className}`}>
      {label ? <span className={labelClassName}>{label} </span> : null}
      {valueNode}
      {secondaryNode}
    </span>
  );
}
